export default {
  free_menu_items: 'Débloqués gratuits',
  discount_badge: '{{value}} de réduction',
  available_at_badge: 'Disponible {{schedule}}',
  restricted_tooltip: "Disponible {{schedule}} — modifiez l'heure de retrait ci-dessus pour commander.",
};
